import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { ModalOptimizationService } from './modal-optimization.service';
import { NotificationsService } from '@app/providers/notifications/notifications.service';
import * as _ from 'lodash';

@Component({
    selector: 'ea-modal-optimization',
    templateUrl: './modal-optimization.component.html',
    styleUrls: ['./modal-optimization.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ModalOptimizationComponent implements OnInit {
  @ViewChild('modalOptimizationTemplate', { static: true })
  modalOptimizationTemplate: TemplateRef<any>;
  modalOptimization: BsModalRef;
  private subscription: Subscription;
  optimization: any;
  newOptimization: any;
  amountSave: any = [];
  constructor(
    private modalService: BsModalService,
    private modalOptimizationService: ModalOptimizationService,
    private notificationsService: NotificationsService,
  ) {}

  ngOnInit() {
    this.subscription = this.modalOptimizationService.modalState.subscribe(
      (optimization?: any) => {
        if (!optimization) this.modalOptimization.hide();
        else {
          var actuel;
          var duration;
          var monthly;
          this.newOptimization = JSON.parse(optimization.value);
          this.newOptimization.map(opti => {
            actuel = _.find(opti, detail => {
              if (detail.label == 'Actuel') return detail;
            });
            duration = _.find(opti, detail => {
              if (detail.label == 'KeepsDuration') return detail;
            });
            monthly = _.find(opti, detail => {
              if (detail.label == 'KeepsMonthly') return detail;
            });
            if (actuel && monthly && duration) {
              var valueEcoIteration = Math.max(
                actuel.loanTotalCost - duration.loanTotalCost,
                actuel.loanTotalCost - monthly.loanTotalCost,
              );
              this.amountSave.push({
                montant: Math.round(valueEcoIteration),
                id: actuel.id,
              });
            }
          });
          this.optimization = optimization;
          this.modalOptimization = this.modalService.show(
            this.modalOptimizationTemplate,
          );
        }
      },
    );
  }
  selectLoan(value) {
    var notification = { route: this.optimization.route, id: value.id };
    this.modalOptimization.hide();
    this.notificationsService.goToNotification(notification);
  }
  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
